import { FC } from 'react'
import { Card, Spin } from 'antd'
import PerFlexRow from '../FlexRow'
import PerSpacer from '../Spacer'
import { ApolloError } from '@apollo/client'
import PerIcon from '../Icon'
import PerText from '../Text'
import { TFunction } from 'i18next'

type LoadingAndErrorsProps = {
  t: TFunction
  isLoading: boolean
  showSpinner: boolean
  hasNoData: boolean
  error?: ApolloError
  customErrorMessage?: string
  backgroundCardHeight?: number
  iconSize?: number
  showOnlyIcon?: boolean
  isPermissionDenied?: boolean
}

export const NewLoadingAndErrors: FC<LoadingAndErrorsProps> = ({
  t,
  isLoading,
  showSpinner,
  error,
  hasNoData,
  backgroundCardHeight,
  customErrorMessage,
  iconSize = 100,
  showOnlyIcon = false,
  isPermissionDenied,
}) => {
  const insufficientRole =
    error &&
    error.graphQLErrors &&
    error.graphQLErrors.length > 0 &&
    error.graphQLErrors[0].extensions &&
    error.graphQLErrors[0].extensions.validationErrors.length === 0 &&
    (error.graphQLErrors[0].extensions.errorKey === 'accessViolation.insufficient.role' ||
      error.graphQLErrors[0].extensions.errorKey === 'permission.not.granted.or.validation.error')

  const originalMessage: string =
    error &&
    error.graphQLErrors &&
    error.graphQLErrors.length > 0 &&
    error.graphQLErrors[0].extensions &&
    error.graphQLErrors[0].extensions.validationErrors.length
      ? error.graphQLErrors[0].extensions.validationErrors[0].message
      : ''

  const message: string =
    insufficientRole || isPermissionDenied
      ? t('page.error.pageUnavailable.insufficientRole')
      : !error && hasNoData
      ? t('page.error.pageUnavailable.noData')
      : !!customErrorMessage
      ? customErrorMessage + ' ' + originalMessage
      : originalMessage

  const errorKey: string =
    error &&
    error.graphQLErrors &&
    error.graphQLErrors.length > 0 &&
    error.graphQLErrors[0].extensions &&
    error.graphQLErrors[0].extensions.validationErrors.length
      ? error.graphQLErrors[0].extensions.validationErrors[0].errorKey
      : ''

  const errorCode: string | undefined = !!errorKey && errorKey.startsWith('error.code') ? errorKey.split('.')[2] : undefined

  const renderIcon = () => {
    return <PerIcon name={'smileyConcerned_stroke'} color={'error'} variant="decoration" size={iconSize} />
  }
  const renderContent = () => {
    return (
      <>
        {isLoading ? (
          <PerFlexRow align="middle" justify="center" className="fullHeight">
            {!!showSpinner && <Spin size="large" spinning />}
          </PerFlexRow>
        ) : showOnlyIcon ? (
          renderIcon()
        ) : (
          <PerFlexRow align="middle" direction="column" justify="center" className="fullHeight">
            <PerSpacer mb="s">{renderIcon()}</PerSpacer>
            <PerText appearance="heading">{t('page.error.pageUnavailable.errorHeading')}</PerText>
            <PerText mt="xxs">{message}</PerText>
            {errorCode && (
              <PerText mt="xxxxs" fontWeight="bold">
                {t('page.error.pageUnavailable.errorCode', { errorCode })}
              </PerText>
            )}
            <PerText mt="xxs" appearance="info">
              {t('page.error.pageUnavailable.contactAdmin')}
            </PerText>
          </PerFlexRow>
        )}
      </>
    )
  }

  return (
    <>
      {backgroundCardHeight ? (
        <Card bordered={false} style={{ height: `${backgroundCardHeight}px` }}>
          {renderContent()}
        </Card>
      ) : (
        renderContent()
      )}
    </>
  )
}
